import { Component } from '@angular/core';

@Component({
    selector: "app-error-page",
    imports: [],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {


  errorMessage = '';
  // // Your data loading logic here
      // this.dataService.loadData().subscribe({
      //   next: (data) => {
      //     this.isLoading = false;
      //     // Handle successful data load
      //   },
      //   error: (error) => {
      //     this.isLoading = false;
      //     this.hasError = true;
      //     this.errorMessage = 'Failed to load data. Please try again.';
      //   }
      // });

}
